import axios from 'axios'

// 获取基础URL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production') {
    // 生产环境使用当前域名
    return window.location.origin + '/api'
  }
  // 开发环境使用环境变量中的URL
  return process.env.VUE_APP_API_URL + '/api'
  // return '/api'

}

// 创建 axios 实例
const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // console.log('request config',config)
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    
    // 添加固定参数 i=1
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        i: 1,
        platform:'h5',
        token:token
      }
    } else {
      config.data = {
        ...config.data,
        i: 1,
        platform:'h5'
      }
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // 处理错误响应
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权
          break
        case 404:
          // 处理未找到
          break
        default:
          // 处理其他错误
          break
      }
    }
    return Promise.reject(error)
  }
)

export default request
